export class ForgotPasswordModel
{
    public email: string;
    public client_id = 'customer-portal';
}
